import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

const mutation = graphql`
    mutation publishEventMutation($input: publishHyeventInput!){
        publishHyevent(input:$input) {
          hyevent{
          additionalGuestAllowed
            id
            status
            title
            publishAt
            campaignTested
          }
        }
    }
`;

function commit(environment, input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
}

export default commit;